var FormLuggageClaims = (function ($) {

    var FormLuggageClaims = function (options) {
        var that = this;

        // DOM
        that.$wrapper = options["$wrapper"];

        // Claim type block
        that.claim_type = {
            damage_shortage: 'damage_shortage',
            loss_shortage: 'loss_shortage',
            delay_delivery: 'delay_delivery',
            lost_cargo: 'lost_cargo',
            lack_contents: 'lack_contents',
        }

        that.claim_type_custom_fields = {
            [that.claim_type.damage_shortage]: '2014',
            [that.claim_type.loss_shortage]: '2015',
            [that.claim_type.delay_delivery]: '2016',
            [that.claim_type.lost_cargo]: '2612',
            [that.claim_type.lack_contents]: '3387',
        }

        that.select_luggage_tag = '.js-luggage-tag';

        that.select_toggle_claim_type = '.js-toggle-claim-type';
        that.$toggle_claim_type = that.$wrapper.find(that.select_toggle_claim_type);

        that.input_files = '.js-file-elem';

        that.$el_claim_type_custom_fields = that.$wrapper.find('.js-form-luggage-claims-custom-fields');

        // luggage info fields
        that.$el_info_type = that.$wrapper.find('.js-info-type');

        // luggage file field
        that.$el_file_type_act = that.$wrapper.find('.js-file-type-act');
        that.$el_file_type_application = that.$wrapper.find('.js-file-type-application');

        that.$el_claim_type_header = that.$wrapper.find('.js-claim-type-header');
        that.$el_claim_type_footer = that.$wrapper.find('.js-claim-type-footer');

        that.$el_agreement_not_found = that.$wrapper.find('.js-agreement-not-found');

        // DYNAMIC VARS
        that.locales = options['locales'] || {};
        that.luggage_blocks = options['luggage_blocks'];

        // INIT
        that.init(options);
    };

    var Self = FormLuggageClaims;
    Self.className = 'FormLuggageClaims';
    var Parent = FormAbstract;

    var def = FormAbstract.def;

    // "inherit"
    Self.prototype = Object.create(Parent.prototype);
    Self.prototype.constructor = Self;

    Self.prototype.init = function (options) {
        var that = this;

        options.onDoneSubmitCallback = function (response) {
            var unique_id = response?.data?.unique_id

            that.$wrapper.find('.js-form-luggage-claims').hide();
            that.$wrapper.find('.js-success-result').show();
            that.$wrapper.find('.js-unique-id').text(unique_id);
            $.sa.scrollToNode(that.$wrapper, 200, null);
        }

        options.onAlertSubmitCallback = function (error) {
            var msg = error && error.message ? error.message : that.locales.error_message;
            $.uiModal({
                header_icons: '<div class="align-center"><i class="fab fa-sa-fill-mood-suprised2"></i><i class="fab fa-sa-fill-circle-x"></i></div>',
                header_title: '<div class="align-center">' + that.locales.error_title + '</div>',
                content: '<div class="align-center">' + msg + '</div>',
                button_align_center: true,
                button_confirm_text: that.locales.confirm_text,
            });
        }

        Parent.prototype.init.call(that, options);

        that.initToggles();

        that.initInputMask();
    };

    Self.prototype.initVars = function (options) {
        var that = this;
        options = options || {};

        that.selectors = {
            form: '.js-form-luggage-claims',
            previous_action: '', //TODO: set this when other password restoration methods would be done
        };

        that.method = 'POST';

        that.url = def(options.url, '');
        that.has_success_screen = false;

        Parent.prototype.initVars.call(that, options);
        that.className = Self.className;
    };

    Self.prototype.initInputMask = function () {
        var that = this;

        UIInputMask.prototype.initINN(that.$wrapper);
        UIInputMask.prototype.initBIK(that.$wrapper);
        UIInputMask.prototype.initAccountNumber(that.$wrapper);
        UIInputMask.prototype.initPnrMask(that.$wrapper);
        UIInputMask.prototype.initEmailValidate(that.$wrapper);
        UIInputMask.prototype.initDateMask(that.$wrapper);
        UIInputMask.prototype.initTimeMask(that.$wrapper);
        UIInputMask.prototype.initPhoneMask(that.$wrapper);
    }

    Self.prototype.initToggles = function () {
        var that = this;
        that.initClaimTypeToggle();
    }

    Self.prototype.initClaimTypeToggle = function () {
        var that = this;
        $.sa.$document.on('change', that.select_toggle_claim_type, function (e) {
            var $toggle_select = $(e.target);

            if ($toggle_select.hasClass(that.select_toggle_claim_type.substring(1))) {
                var selected_type = $toggle_select.val();

                that.$el_claim_type_header.show();
                that.$el_claim_type_footer.show();

                // reset claim type fields
                that.$el_info_type.empty();
                that.$el_file_type_act.hide();
                that.$el_file_type_application.hide();
                that.$el_agreement_not_found.hide();
                that.$wrapper.find(that.input_files).attr('name', '');
                
                // show luggage additional fields by claim type
                var $el_info_type_selected = $(that.luggage_blocks[selected_type] ?? null);
                if ($el_info_type_selected) {
                    that.$el_info_type.append($el_info_type_selected);
                    that.initInputMask();
                }

                // show additional agreement
                if(selected_type === that.claim_type.loss_shortage) {
                    that.$el_agreement_not_found.show();
                }

                // show file block
                if ([that.claim_type.damage_shortage, that.claim_type.lack_contents].includes(selected_type)) {
                    that.$el_file_type_act.show();
                    that.$el_file_type_act.find(that.input_files).attr('name', 'files[]');
                } else {
                    that.$el_file_type_application.show();
                    that.$el_file_type_application.find(that.input_files).attr('name', 'files[]');
                }

                that.$el_claim_type_custom_fields.val(that.claim_type_custom_fields[selected_type]);
            }

        });
    }

    return Self;
})(jQuery);